/* tslint:disable */
/* eslint-disable */
/**
 * Bank Accounts API
 * API for managing bank accounts
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AttachRibCommand,
  CopyBankAccountCommand,
  CreateBankAccountCommand,
  CreateBankAccountFromRibCommand,
  CreateMyBankAccountCommand,
  ErrorResponse,
  GetBankAccountListResponseDto,
  GetBankAccountResponseDto,
  OperationResponse,
  SelectRibForDevisCommand,
  UpdateBankAccountCommand,
} from '../models/index';
import {
    AttachRibCommandFromJSON,
    AttachRibCommandToJSON,
    CopyBankAccountCommandFromJSON,
    CopyBankAccountCommandToJSON,
    CreateBankAccountCommandFromJSON,
    CreateBankAccountCommandToJSON,
    CreateBankAccountFromRibCommandFromJSON,
    CreateBankAccountFromRibCommandToJSON,
    CreateMyBankAccountCommandFromJSON,
    CreateMyBankAccountCommandToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    GetBankAccountListResponseDtoFromJSON,
    GetBankAccountListResponseDtoToJSON,
    GetBankAccountResponseDtoFromJSON,
    GetBankAccountResponseDtoToJSON,
    OperationResponseFromJSON,
    OperationResponseToJSON,
    SelectRibForDevisCommandFromJSON,
    SelectRibForDevisCommandToJSON,
    UpdateBankAccountCommandFromJSON,
    UpdateBankAccountCommandToJSON,
} from '../models/index';

export interface AttachRibToBankAccountRequest {
    compteBancaireId: string;
    attachRibCommand: AttachRibCommand;
}

export interface CopyBankAccountRequest {
    compteBancaireId: string;
    copyBankAccountCommand: CopyBankAccountCommand;
    risqueAssureId?: string;
}

export interface CreateBankAccountRequest {
    createBankAccountCommand: CreateBankAccountCommand;
}

export interface CreateBankAccountFromRibRequest {
    createBankAccountFromRibCommand: CreateBankAccountFromRibCommand;
}

export interface CreateMyBankAccountRequest {
    createMyBankAccountCommand: CreateMyBankAccountCommand;
}

export interface DeleteBankAccountRequest {
    id: string;
}

export interface GetBankAccountByIdRequest {
    id: string;
}

export interface GetBankAccountsByPersonIdRequest {
    personId: string;
}

export interface GetDefaultBankAccountByPersonIdRequest {
    personId: string;
}

export interface SelectRibForDevisRequest {
    selectRibForDevisCommand: SelectRibForDevisCommand;
}

export interface UpdateBankAccountRequest {
    id: string;
    updateBankAccountCommand: UpdateBankAccountCommand;
}

/**
 * 
 */
export class BankAccountsApi extends runtime.BaseAPI {

    /**
     * Attaches a RIB document to an existing bank account that doesn\'t have one. Used when the broker selects an existing account without RIB.
     * Attach RIB to bank account
     */
    async attachRibToBankAccountRaw(requestParameters: AttachRibToBankAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['compteBancaireId'] == null) {
            throw new runtime.RequiredError(
                'compteBancaireId',
                'Required parameter "compteBancaireId" was null or undefined when calling attachRibToBankAccount().'
            );
        }

        if (requestParameters['attachRibCommand'] == null) {
            throw new runtime.RequiredError(
                'attachRibCommand',
                'Required parameter "attachRibCommand" was null or undefined when calling attachRibToBankAccount().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/comptes/{compteBancaireId}/attach-rib`.replace(`{${"compteBancaireId"}}`, encodeURIComponent(String(requestParameters['compteBancaireId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AttachRibCommandToJSON(requestParameters['attachRibCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Attaches a RIB document to an existing bank account that doesn\'t have one. Used when the broker selects an existing account without RIB.
     * Attach RIB to bank account
     */
    async attachRibToBankAccount(requestParameters: AttachRibToBankAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.attachRibToBankAccountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Copies an existing bank account (IBAN, BIC, label, RIB) onto another person, typically the co-borrower. Idempotent: returns the existing account if the target person already has this IBAN. The copy is a distinct account.
     * Copy bank account to another person
     */
    async copyBankAccountRaw(requestParameters: CopyBankAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['compteBancaireId'] == null) {
            throw new runtime.RequiredError(
                'compteBancaireId',
                'Required parameter "compteBancaireId" was null or undefined when calling copyBankAccount().'
            );
        }

        if (requestParameters['copyBankAccountCommand'] == null) {
            throw new runtime.RequiredError(
                'copyBankAccountCommand',
                'Required parameter "copyBankAccountCommand" was null or undefined when calling copyBankAccount().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['risqueAssureId'] != null) {
            queryParameters['risqueAssureId'] = requestParameters['risqueAssureId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/comptes/{compteBancaireId}/copier`.replace(`{${"compteBancaireId"}}`, encodeURIComponent(String(requestParameters['compteBancaireId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CopyBankAccountCommandToJSON(requestParameters['copyBankAccountCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Copies an existing bank account (IBAN, BIC, label, RIB) onto another person, typically the co-borrower. Idempotent: returns the existing account if the target person already has this IBAN. The copy is a distinct account.
     * Copy bank account to another person
     */
    async copyBankAccount(requestParameters: CopyBankAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.copyBankAccountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new bank account for a person
     * Create new bank account
     */
    async createBankAccountRaw(requestParameters: CreateBankAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['createBankAccountCommand'] == null) {
            throw new runtime.RequiredError(
                'createBankAccountCommand',
                'Required parameter "createBankAccountCommand" was null or undefined when calling createBankAccount().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/comptes`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateBankAccountCommandToJSON(requestParameters['createBankAccountCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Creates a new bank account for a person
     * Create new bank account
     */
    async createBankAccount(requestParameters: CreateBankAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.createBankAccountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a bank account from an uploaded RIB document. The IBAN is validated/modified by the user after OCR extraction.
     * Create bank account from RIB
     */
    async createBankAccountFromRibRaw(requestParameters: CreateBankAccountFromRibRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['createBankAccountFromRibCommand'] == null) {
            throw new runtime.RequiredError(
                'createBankAccountFromRibCommand',
                'Required parameter "createBankAccountFromRibCommand" was null or undefined when calling createBankAccountFromRib().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/comptes/from-rib`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateBankAccountFromRibCommandToJSON(requestParameters['createBankAccountFromRibCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Creates a bank account from an uploaded RIB document. The IBAN is validated/modified by the user after OCR extraction.
     * Create bank account from RIB
     */
    async createBankAccountFromRib(requestParameters: CreateBankAccountFromRibRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.createBankAccountFromRibRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new bank account for the currently authenticated user. The person is resolved from the JWT token.
     * Create a bank account for the connected user
     */
    async createMyBankAccountRaw(requestParameters: CreateMyBankAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['createMyBankAccountCommand'] == null) {
            throw new runtime.RequiredError(
                'createMyBankAccountCommand',
                'Required parameter "createMyBankAccountCommand" was null or undefined when calling createMyBankAccount().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/comptes/courtier-connecte`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateMyBankAccountCommandToJSON(requestParameters['createMyBankAccountCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Creates a new bank account for the currently authenticated user. The person is resolved from the JWT token.
     * Create a bank account for the connected user
     */
    async createMyBankAccount(requestParameters: CreateMyBankAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.createMyBankAccountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Deletes a specific bank account by its unique identifier
     * Delete bank account
     */
    async deleteBankAccountRaw(requestParameters: DeleteBankAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteBankAccount().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/comptes/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Deletes a specific bank account by its unique identifier
     * Delete bank account
     */
    async deleteBankAccount(requestParameters: DeleteBankAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.deleteBankAccountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves a specific bank account by its unique identifier
     * Get bank account by ID
     */
    async getBankAccountByIdRaw(requestParameters: GetBankAccountByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetBankAccountResponseDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getBankAccountById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/comptes/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetBankAccountResponseDtoFromJSON(jsonValue));
    }

    /**
     * Retrieves a specific bank account by its unique identifier
     * Get bank account by ID
     */
    async getBankAccountById(requestParameters: GetBankAccountByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetBankAccountResponseDto> {
        const response = await this.getBankAccountByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves all bank accounts associated with a specific person
     * Get bank accounts by person ID
     */
    async getBankAccountsByPersonIdRaw(requestParameters: GetBankAccountsByPersonIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetBankAccountListResponseDto>> {
        if (requestParameters['personId'] == null) {
            throw new runtime.RequiredError(
                'personId',
                'Required parameter "personId" was null or undefined when calling getBankAccountsByPersonId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/comptes/personne/{personId}`.replace(`{${"personId"}}`, encodeURIComponent(String(requestParameters['personId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetBankAccountListResponseDtoFromJSON(jsonValue));
    }

    /**
     * Retrieves all bank accounts associated with a specific person
     * Get bank accounts by person ID
     */
    async getBankAccountsByPersonId(requestParameters: GetBankAccountsByPersonIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetBankAccountListResponseDto> {
        const response = await this.getBankAccountsByPersonIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves the default bank account for a specific person
     * Get default bank account by person ID
     */
    async getDefaultBankAccountByPersonIdRaw(requestParameters: GetDefaultBankAccountByPersonIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetBankAccountResponseDto>> {
        if (requestParameters['personId'] == null) {
            throw new runtime.RequiredError(
                'personId',
                'Required parameter "personId" was null or undefined when calling getDefaultBankAccountByPersonId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/comptes/personne/{personId}/default`.replace(`{${"personId"}}`, encodeURIComponent(String(requestParameters['personId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetBankAccountResponseDtoFromJSON(jsonValue));
    }

    /**
     * Retrieves the default bank account for a specific person
     * Get default bank account by person ID
     */
    async getDefaultBankAccountByPersonId(requestParameters: GetDefaultBankAccountByPersonIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetBankAccountResponseDto> {
        const response = await this.getDefaultBankAccountByPersonIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves all bank accounts associated with the currently authenticated user. The person is resolved from the JWT token.
     * Get bank accounts of the connected user
     */
    async getMyBankAccountsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetBankAccountListResponseDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/comptes/courtier-connecte`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetBankAccountListResponseDtoFromJSON(jsonValue));
    }

    /**
     * Retrieves all bank accounts associated with the currently authenticated user. The person is resolved from the JWT token.
     * Get bank accounts of the connected user
     */
    async getMyBankAccounts(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetBankAccountListResponseDto> {
        const response = await this.getMyBankAccountsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Selects a bank account (RIB) for a quote in the manual contractualization process. Creates the associated document and adds it to the quote snapshot.
     * Select RIB for quote
     */
    async selectRibForDevisRaw(requestParameters: SelectRibForDevisRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['selectRibForDevisCommand'] == null) {
            throw new runtime.RequiredError(
                'selectRibForDevisCommand',
                'Required parameter "selectRibForDevisCommand" was null or undefined when calling selectRibForDevis().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/rib-selection/select-for-devis`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SelectRibForDevisCommandToJSON(requestParameters['selectRibForDevisCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Selects a bank account (RIB) for a quote in the manual contractualization process. Creates the associated document and adds it to the quote snapshot.
     * Select RIB for quote
     */
    async selectRibForDevis(requestParameters: SelectRibForDevisRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.selectRibForDevisRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates an existing bank account with new information
     * Update bank account
     */
    async updateBankAccountRaw(requestParameters: UpdateBankAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateBankAccount().'
            );
        }

        if (requestParameters['updateBankAccountCommand'] == null) {
            throw new runtime.RequiredError(
                'updateBankAccountCommand',
                'Required parameter "updateBankAccountCommand" was null or undefined when calling updateBankAccount().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/comptes/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateBankAccountCommandToJSON(requestParameters['updateBankAccountCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Updates an existing bank account with new information
     * Update bank account
     */
    async updateBankAccount(requestParameters: UpdateBankAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.updateBankAccountRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
